import type { BatchProcessItemDto } from "@fp/admin-api-client";
import {
  FsmSyncItemMetadataDtoKind,
  PayoutApprovalItemMetadataDtoKind,
  SimulationItemMetadataDtoKind,
} from "@fp/admin-api-client";
import { formatCurrency } from "@/lib/format-currency";

export function getBatchItemTitle(item: BatchProcessItemDto): string {
  const { metadata } = item;

  switch (metadata?.kind) {
    case FsmSyncItemMetadataDtoKind.fsmSync:
      return `${item.referenceType} ${metadata.sourceReference ?? item.referenceId}`;
    case PayoutApprovalItemMetadataDtoKind.payoutApproval:
      return metadata.amount == null
        ? metadata.payeeName
        : `${metadata.payeeName} · $${formatCurrency(metadata.amount)}`;
    case SimulationItemMetadataDtoKind.simulation:
      return `Simulated item ${metadata.index}`;
    default:
      return item.referenceId;
  }
}